import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { userAtom } from 'core/config/atoms';

import { AnimatePresence, motion } from "framer-motion";

import { CalendarCheck2Icon, ChartPie, ReceiptIndianRupeeIcon } from 'lucide-react';

import PanelDev from 'panels/dev/PanelDev';
import PanelSubscription from 'panels/reports/PanelSubscription';
import PanelTransaction from 'panels/reports/PanelTransaction';
import PanelTask from 'panels/reports/PanelTask';

export default function LayoutReport() {

    const { page } = useParams();

    const [userData, setUserData] = useRecoilState(userAtom);

    const [isOpen, setIsOpen] = useState(true);

    const itemVariants = {
        closed: { opacity: 0 },
        open: { opacity: 1 }
    };

    const navigate = useNavigate();

    const changeNav = (link) => {
        navigate(`/${link}`);
        setIsOpen(true);
    }

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <AnimatePresence>
                {
                    isOpen && <motion.div initial={{ width: 0 }} animate={{ width: '14%' }} exit={{ width: 0, transition: { delay: 0.2, duration: 0.3 } }} className="h-screen bg-slate-100 w-[14%]">
                        <div className='w-full p-3'>
                            <motion.h1 initial="closed" animate="open" exit="closed" variants={itemVariants} className="text-2xl font-medium rounded">Reports</motion.h1>
                            <motion.ul initial="closed" animate="open" exit="closed" variants={itemVariants} className="flex flex-col items-start space-y-2 mt-4">
                                <li className={`w-full cursor-pointer text-base p-1.5 hover:bg-gray-200 rounded flex items-center ${page === 'reports' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('reports') }}>
                                    <CalendarCheck2Icon size={20} className='mr-2' /> Subscriptions
                                </li>
                                <li className={`w-full cursor-pointer text-base p-1.5 hover:bg-gray-200 rounded flex items-center ${page === 'trns' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('trns') }}>
                                    <ReceiptIndianRupeeIcon size={20} className='mr-2' /> Transactions
                                </li>
                                <li className={`w-full cursor-pointer text-base p-1.5 hover:bg-gray-200 rounded flex items-center ${page === 'task' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('task') }}>
                                    <ChartPie size={20} className='mr-2' /> Task
                                </li>
                            </motion.ul>
                        </div>
                    </motion.div>
                }
            </AnimatePresence>
            <div className='h-screen w-[86%]'>
                {
                    (() => {
                        switch (page) {
                            case 'reports':
                                return (<PanelSubscription onToggle={toggleMenu} />);
                            case 'trns':
                                return (<PanelTransaction onToggle={toggleMenu} />);
                            case 'task':
                                return (<PanelTask onToggle={toggleMenu} />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </>
    )
}
